import { Button, Divider, FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import React, { useState } from "react";
import FileUploader from "../Components/FileUploader";
import { useLoader } from "../providers";

export const AddNewStatute = () => {
  const [formErrors, setFormErrors] = useState<any>({});
  const [touchedFields, setTouchedFields] = useState<any>({});
  const { showLoader, hideLoader } = useLoader();

  const [formValue, setFormValues] = useState({
    title: '',
    date: '',
    act: '',
    type: '',
    group: '',
    subGroup: '',
  });

  const handleInputChange = (event: any) => {
    const { name, value } = event.target;
    let newErrors: any = {};
    let updatedFormValue = { ...formValue, [name]: value };
    switch (name) {
      case 'title':
        if (!value) {
          newErrors.title = 'Title is required';
        } else {
          delete formErrors.title;
        }
        break;
      case 'act':
        if (!value) {
          newErrors.act = 'Act is required';
        } else {
          delete formErrors.act;
        }
        break;
      case 'date':
        if (!value) {
          newErrors.date = 'Date is required';
        } else {
          delete formErrors.date;
        }
        break;
      default:
        break;
    }
    setFormValues(updatedFormValue);
    setFormErrors((prevErrors: any) => {
      return { ...prevErrors, ...newErrors };
    });
  };

  const handleFieldBlur = (event: any) => {
    const { name } = event.target;
    setTouchedFields((prevTouched: any) => {
      return { ...prevTouched, [name]: true };
    });
  };

  const [uploadedFiles, setUploadedFiles] = useState([]);

  // Callback function to receive selected files from FileUploader
  const handleFilesUploaded = (files: any) => {
    setUploadedFiles(files);
  };

  const saveNewStatute = () => {
    const requestBody = {
      title: formValue.title,
      files: uploadedFiles,
      date: formValue.date,
      act: formValue.act,
      type: formValue.type,
      group: formValue.group,
      sub_group: formValue.subGroup,
      practice_areas: '',
    };

    console.log('see this ==> ', requestBody)
  }

  return (
    <div className="flex flex-1 flex-col gap-4 w-full h-full">
      <div className="flex flex-col flex-1 bg-white w-full p-8 rounded-xl shadow-xl gap-6">
        <p className="text-2xl font-bold">Add New Statute</p>
        <hr />
        <div className="flex flex-col gap-4 max-w-[40rem]">
          <div className="flex flex-col gap-2 w-full">
            <p className="font-bold pt-1">Title</p>
            <FormControl fullWidth>
              <TextField
                size='small'
                placeholder='Enter Statute Title'
                variant='outlined'
                name='title'
                type={'text'}
                required
                onChange={handleInputChange}
                value={formValue.title}
                onBlur={handleFieldBlur}
                error={!!(formErrors.title && touchedFields.title)}
                helperText={touchedFields.title ? formErrors.title : ""}
              />
            </FormControl>
          </div>

          <div className="flex flex-row gap-4">
            <div className="flex flex-col gap-2 w-full">
              <p className="font-bold pt-1">Act</p>
              <FormControl fullWidth>
                <TextField
                  size='small'
                  placeholder='Enter Statute Act'
                  variant='outlined'
                  name='act'
                  type={'text'}
                  required
                  onChange={handleInputChange}
                  value={formValue.act}
                  onBlur={handleFieldBlur}
                  error={!!(formErrors.act && touchedFields.act)}
                  helperText={touchedFields.act ? formErrors.act : ""}
                />
              </FormControl>
            </div>
            <div className="flex flex-col gap-2 w-full">
              <p className="font-bold pt-1">Date</p>
              <FormControl fullWidth>
                <TextField
                  size='small'
                  placeholder='Enter Date'
                  variant='outlined'
                  name='date'
                  type={'date'}
                  required
                  onChange={handleInputChange}
                  value={formValue.date}
                  onBlur={handleFieldBlur}
                  error={!!(formErrors.date && touchedFields.date)}
                  helperText={touchedFields.date ? formErrors.date : ""}
                />
              </FormControl>
            </div>
          </div>

          <div className="flex flex-row gap-4 my-4">
            <FormControl fullWidth size='small'>
              <InputLabel id='select-type'>Select Type</InputLabel>
              <Select
                labelId='select-type'
                id='demo-simple-select-helper'
                variant='outlined'
                value={formValue.type}
                label='Select Type'
                required
                onChange={handleInputChange}
                onBlur={handleFieldBlur}
                error={!!(formErrors.type && touchedFields.type)}
              >
                <MenuItem value={'all'}>All</MenuItem>
                <MenuItem value={'primary'}>Primary</MenuItem>
                <MenuItem value={'secondary'}>Secondary</MenuItem>
                <MenuItem value={'bills'}>Bills</MenuItem>
                <MenuItem value={'amendment act'}>Amendments</MenuItem>
              </Select>
            </FormControl>
            <FormControl fullWidth size='small'>
              <InputLabel id='select-type'>Select Group</InputLabel>
              <Select
                labelId='select-type'
                id='demo-simple-select-helper'
                variant='outlined'
                value={formValue.type}
                label='Select Group'
                required
                onChange={handleInputChange}
                onBlur={handleFieldBlur}
                error={!!(formErrors.type && touchedFields.type)}
              >
                <MenuItem value={'all'}>All</MenuItem>
                <MenuItem value={'primary'}>Primary</MenuItem>
                <MenuItem value={'secondary'}>Secondary</MenuItem>
                <MenuItem value={'bills'}>Bills</MenuItem>
                <MenuItem value={'amendment act'}>Amendments</MenuItem>
              </Select>
            </FormControl>
            <FormControl fullWidth size='small'>
              <InputLabel id='select-type'>Select Sub-Group</InputLabel>
              <Select
                labelId='select-type'
                id='demo-simple-select-helper'
                variant='outlined'
                value={formValue.type}
                label='Select Sub-Group'
                required
                onChange={handleInputChange}
                onBlur={handleFieldBlur}
                error={!!(formErrors.type && touchedFields.type)}
              >
                <MenuItem value={'all'}>All</MenuItem>
                <MenuItem value={'primary'}>Primary</MenuItem>
                <MenuItem value={'secondary'}>Secondary</MenuItem>
                <MenuItem value={'bills'}>Bills</MenuItem>
                <MenuItem value={'amendment act'}>Amendments</MenuItem>
              </Select>
            </FormControl>
          </div>

          {/* Use the FileUploader component and pass the callback function */}
          <div className="flex flex-col gap-2 w-full">
            <p className="font-bold pt-1">Upload Statute Documents</p>
            <FileUploader onFilesUploaded={handleFilesUploaded} containerLabel="Statute Document(s)" />
          </div>
        </div>

        <Divider />

        <Button
          type="submit"
          className="w-60"
          variant="contained"
          color='primary'
          onClick={saveNewStatute}
        >
          Save
        </Button>

      </div>
    </div>
  );
}